import {
  compose,
  flattenProp,
  withHandlers,
  withStateHandlers,
} from 'recompose';
import { injectIntl } from 'react-intl';
import { addProps, addIntlProps } from 'utils/recompose';
import { connect } from 'react-redux';
import {
  template,
  designPackageForTemplate,
  charmsForTemplate,
} from 'reducers/templates/selectors';
import { mini } from 'reducers/dashboard/selectors';
import combineSelectors from 'utils/combineSelectors';
import formatCurrency from 'utils/formatCurrency';
import messages from './messages';
import { addTemplateToWorkingState } from 'reducers/models/actions';
import { priceBands, inReviewTemplateIds } from 'reducers/models/selectors';
import bmwAddIcon from './search-add-template-plus.svg';
import miniAddIcon from './mini-btn-plus.svg';
import { differenceWith, isEqual } from 'lodash';

const mapStateToProps = combineSelectors({
  template,
  designPackageForTemplate,
  priceBands,
  mini,
  charmsForTemplate,
  inReviewTemplateIds,
});

const priceBand = ({ priceBands, priceBandId }) =>
  priceBands.find(priceBand => priceBand.id === priceBandId);
const priceBandMax = ({ priceBand }) => priceBand.max;
const priceBandMin = ({ priceBand }) => priceBand.min;

const addTemplate = ({ addTemplateToWorkingState, template }) => () => {
  let { id, modelId } = template;
  addTemplateToWorkingState(modelId, id);
};

const formattedTotal = formatCurrency({
  priceProp: 'totalPrice',
  currencyProp: 'currency',
});

const formattedDesignPrice = formatCurrency({
  priceProp: 'designPrice',
  currencyProp: 'currency',
});

const formattedPriceBandMax = formatCurrency({
  priceProp: 'priceBandMax',
  currencyProp: 'currency',
});

const formattedPriceBandMin = formatCurrency({
  priceProp: 'priceBandMin',
  currencyProp: 'currency',
});

export const formattedPriceBand = ({
  formattedPriceBandMin,
  formattedPriceBandMax,
  priceBand,
}) => {
  if (priceBand.max < 1000000) {
    return `${formattedPriceBandMin} - ${formattedPriceBandMax}`;
  } else {
    return `${formattedPriceBandMin}+`;
  }
};

export const displayPlaceholder = ({ inReviewTemplateIds, templateId }) => {
  return inReviewTemplateIds.includes(templateId);
};

const expand = ({ expanded }) => () => {
  return { expanded: !expanded };
};

const collapse = () => () => {
  return { expanded: false };
};

export const primaryOptions = () => [
  'paintOption',
  'interiorOption',
  'wheelOption',
];

export const secondaryOptions = ({
  primaryOptions,
  designPackageForTemplate,
}) => {
  return differenceWith(
    designPackageForTemplate.optionKeys,
    primaryOptions,
    isEqual,
  );
};

export const closeSelection = () => () => ({ selectedDesignOption: null });
export const onClickOrTouch = () => selectedDesignOption => ({
  selectedDesignOption,
});

export const addIcon = ({ mini }) => (mini ? miniAddIcon : bmwAddIcon);

export default compose(
  injectIntl,
  addIntlProps({
    messages,
    propNames: ['currency', 'addedToReview'],
  }),
  connect(
    mapStateToProps,
    {
      addTemplateToWorkingState,
    },
  ),
  flattenProp('template'),
  flattenProp('designPackageForTemplate'),
  withHandlers({
    addTemplate,
  }),
  withStateHandlers(
    { selectedDesignOption: null },
    { closeSelection, onClickOrTouch },
  ),
  withStateHandlers(
    { expanded: false },
    {
      expand,
      collapse,
    },
  ),
  addProps({
    priceBand,
  }),
  addProps({
    priceBandMax,
    priceBandMin,
    primaryOptions,
  }),
  addProps({
    formattedTotal,
    formattedDesignPrice,
    formattedPriceBandMax,
    formattedPriceBandMin,
    addIcon,
    secondaryOptions,
    displayPlaceholder,
  }),
  addProps({
    formattedPriceBand,
  }),
);
